import { get, size } from 'lodash';
import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  UPDATE_USER_INFO,
  USER_PROFILE_STORAGE_KEY
} from '../actions/auth-actions';

const storedUserProfile = JSON.parse(
  localStorage.getItem(USER_PROFILE_STORAGE_KEY)
);

const initialState = {
  avatar: null,
  allowedPages: [],
  allowedDataCategories: [],
  userId: null,
  username: null,
  email: null,
  organization: null,
  apiKey: null,
  apiSecret: null,
  ...storedUserProfile
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        allowedPages: action.allowedPages,
        allowedDataCategories: action.allowedDataCategories,
        avatar: action.avatar,
        userId: action.userId,
        username: action.username,
        lastname: action.lastname,
        email: action.email,
        organization: action.organization,
        apiKey: action.apiKey,
        apiSecret: action.apiSecret
      };
    case LOGOUT_SUCCESS:
      return {
        allowedPages: [],
        allowedDataCategories: [],
        avatar: null,
        userId: null,
        username: null,
        lastname: null,
        email: null,
        organization: null,
        apiKey: null,
        apiSecret: null
      };
    case UPDATE_USER_INFO:
      return {
        ...state,
        ...action.userInfo
      };
    default:
      return state;
  }
}

export const getUserInfo = state => get(state, 'user', {});
export const selectUserId = state => get(state, ['user', 'userId'], '');
export const selectAllowedPages = state =>
  get(state, ['user', 'allowedPages'], []);
export const selectFirstAllowedPage = state =>
  get(state, ['user', 'allowedPages', 0], '');
export const hasOnlyGEMReportPage = state =>
  selectAllowedPages(state).includes('/gem-report') &&
  size(selectAllowedPages(state)) === 1;
